import { Component } from '@angular/core';

@Component({
  templateUrl: './slider.html'  
})
export class SliderComponent { 
    constructor() { }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/slider/slider-component.ts